export default __webpack_public_path__ + "static/media/tab_home_active.08bce09a.svg";